import './global-search/__index.js';
import { initAccountMenu } from './account-menu.js';
import { initCoverReactiveCardGlow } from './cover-reactive-card-glow.js';
import { initDisclosurePanels } from './disclosure-panel.js';
import { initFocusReveal } from './focus-reveal.js';
import { initGuestSoftPrompt } from './guest-soft-prompt.js';
import { initGuestTermsConsent } from './guest-terms-consent.js';
import { initTermsNotice } from './terms-notice.js';
import { initFlashToasts } from './toast.js';
import { initAjaxPagination } from './ajax-pagination.js';

initAjaxPagination();
initFlashToasts();
initAccountMenu();
initCoverReactiveCardGlow();
initDisclosurePanels();
initFocusReveal();
if (!initGuestTermsConsent() && !initTermsNotice()) {
    initGuestSoftPrompt();
}
